import { useNavigate } from "react-router";

import { LoginAppRoutes } from "../constants/routes";
import {
  saveUsingCognitoCookies,
  saveAuthToken,
  initTenantSelection,
  cleanUserArtifacts,
  setIsSjAdminToStorage,
} from "../utils";
import { savePathForRedirect, getAndRemovePathForRedirect } from "../utils/redirectStorage";

export const useLoginFlow = () => {
  let navigate;
  try {
    navigate = useNavigate();
  } catch (_error) {
    // If useNavigate fails (not in Router context), we'll handle navigation differently
    navigate = null;
  }

  const handleRedirectAfterLogin = async () => {
    const redirectPath = getAndRemovePathForRedirect() || "/";
    window.location.assign(redirectPath);
  };

  const handlePostLogin = async (token: string, sjAdmin: boolean) => {
    saveAuthToken(token);
    saveUsingCognitoCookies();

    // If this is an sjAdmin login, save that to localStorage and then redirect to tenant list
    if (sjAdmin) {
      setIsSjAdminToStorage();
      if (navigate) {
        navigate(LoginAppRoutes.routes.tenantList.route);
      } else {
        window.location.assign(LoginAppRoutes.routes.tenantList.route);
      }
      return;
    }

    // Handle tenant selection flow
    const tenantSelected = await initTenantSelection();
    if (!tenantSelected) {
      if (navigate) {
        navigate(LoginAppRoutes.routes.tenantSelection.route);
      } else {
        window.location.assign(LoginAppRoutes.routes.tenantSelection.route);
      }
      return;
    } else {
      handleRedirectAfterLogin();
    }
  };

  const handleUnauthedAccess = () => {
    savePathForRedirect(window.location.pathname + window.location.search);
    cleanUserArtifacts();
    window.location.assign(LoginAppRoutes.routes.signedOut.route);
  };

  return { handlePostLogin, handleRedirectAfterLogin, handleUnauthedAccess };
};
